import { useMemo } from 'react';
import { useDappState } from './useDappState';

export const useViewTransition = () => {
  const { isPuzzleWalletWebview } = useDappState();

  const slideLeftFullPage = useMemo(() => {
    return isPuzzleWalletWebview
      ? { types: ['slide-left-full-page'] }
      : undefined;
  }, [isPuzzleWalletWebview]);

  const slideRightFullPage = useMemo(() => {
    return isPuzzleWalletWebview
      ? { types: ['slide-right-full-page'] }
      : undefined;
  }, [isPuzzleWalletWebview]);

  const slideLeftPartial = useMemo(() => {
    return isPuzzleWalletWebview
      ? { types: ['slide-left-partial'] }
      : undefined;
  }, [isPuzzleWalletWebview]);

  const slideRightPartial = useMemo(() => {
    return isPuzzleWalletWebview
      ? { types: ['slide-right-partial'] }
      : undefined;
  }, [isPuzzleWalletWebview]);

  return {
    slideLeftFullPage,
    slideRightFullPage,
    slideLeftPartial,
    slideRightPartial,
  };
};
